import { useEffect, useState } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';
import { Wrapper, LocalePickerWrapper } from './Header.styles';
import LocalePicker from 'components/features/login/locale-picker/localePicker';
import { routes } from 'utils/constants';
import { LogoImage } from './LogoImage';
import { useViewport, Viewport } from 'hooks/use-viewport/use-viewport';
import { getIsNative } from 'utils/helpers';

export const Header = () => {
  const router = useRouter();
  const { isReady, query } = router;
  const [showLocalePicker, setShowLocalePicker] = useState<boolean>(true);
  const viewport: Viewport = useViewport();

  useEffect(() => {
    if (!isReady) return;
    // Natives set the is_native query param to true in browser tabs when using webview
    if (getIsNative(query)) {
      setShowLocalePicker(false);
    }
  }, [isReady, query?.is_native]);

  const localPickerComponent = showLocalePicker ? (
    <LocalePickerWrapper data-testid='locale-picker-wrapper'>
      <LocalePicker showLabel={false} />
    </LocalePickerWrapper>
  ) : null;

  return (
    <Wrapper data-testid='main-header'>
      {viewport === 'mobile' && localPickerComponent}
      <Link
        href={{
          pathname: routes['/login'],
          query: router.query,
        }}
        data-testid='login-link'
      >
        <LogoImage />
      </Link>
      {viewport !== 'mobile' && localPickerComponent}
    </Wrapper>
  );
};
